module.exports = __webpack_public_path__ + "img/zsgg-4.4e05845f.png";